import React from "react";
import "./ProductDetails.css"; 

const ProductDetails = ({ product }) => {
  // Function to render stars based on averageRating, defaulting to 5 if 0 or undefined
  const renderStars = (rating) => {
    const effectiveRating = rating > 0 ? rating : 5; // Default to 5 if rating is 0 or undefined
    const fullStars = effectiveRating; // Already rounded to an integer in ProductDetailsPage.js
    const emptyStars = 5 - fullStars; // Remaining empty stars

    return (
      <>
        {Array(fullStars)
          .fill("★")
          .map((star, index) => (
            <span key={`full-${index}`} style={{ color: "#ffd700" }}>
              {star}
            </span>
          ))}
        {Array(emptyStars)
          .fill("☆")
          .map((star, index) => (
            <span key={`empty-${index}`} style={{ color: "#ffd700" }}>
              {star}
            </span>
          ))}
      </>
    );
  };

  return (
    <div
      style={{
        // backgroundColor: "#fff",
        padding: "12px 0px",
        borderRadius: "8px",
        // boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
        marginBottom: "40px",
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        textAlign: "center",
        // maxWidth: "600px",
        margin: "0 auto",
        // border: "1px solid #f0f0f0",
      }}
    >
      {/* Product Name */}
      <div className="product-name-container">

        <h2 className="productName"> {product.name} </h2>
        <span className="badge bg-warning text-dark newArrival">
          New Arrival
        </span>

      </div>

      {/* Discount and Badge */}
      {/* <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          marginBottom: "15px",
        }}
      >
        <h5
          style={{
            color: "#dc3545",
            fontSize: "1.25rem",
            fontWeight: "500",
            margin: 0,
          }}
        >
          {product.discount ? `${product.discount} off` : "No discount available"}
        </h5>
        <span
          className="badge bg-warning text-dark"
          style={{
            fontSize: "0.9rem",
            padding: "5px 10px",
          }}
        >
          New Arrival
        </span>
      </div> */}

      {/* Price */}

      <div
        style={{
          display: "flex",
          alignItems: "end",
          gap: "12px",
          marginBottom: "15px",
        }}
      >
        <h4
          style={{
            fontSize: "1.5rem",
            fontWeight: "700",
            // color: "#28a745",
            color: "#282c3f",
            margin: 0,
            // marginBottom: "15px",
          }}
        >
          ₹ {product.price}{" "}
        </h4>
        <p
          style={{
            fontSize: "1rem",
            color: "#6c757d",
            margin: 0,
            textDecoration: "line-through",
          }}
        >
          ₹{product.originalPrice}
        </p>
        <p
          style={{
            color: "#dc3545",
            fontSize: "1rem",
            fontWeight: "500",
            margin: 0,
          }}
        >
          {product.discount
            ? `${product.discount} off`
            : "No discount available"}
        </p>
      </div>

      {/* Rating Section */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "15px",
          lineHeight: 0.5,
        }}
      >
        <div style={{ fontSize: "23px" }}>
          {renderStars(product.averageRating)}
        </div>
        <p
          style={{
            fontSize: "14px",
            color: "#555",
            margin: 0,
          }}
        >
          ({product.ratingsCount}{" "}
          {product.ratingsCount === 1 ? "rating" : "ratings"})
        </p>
      </div>

      {/* Additional Info */}
      <p
        style={{
          fontSize: "14px",
          color: "#6c757d",
          marginBottom: "15px",
        }}
      >
        GST included. Free delivery on your order.
      </p>

      {/* description Info */}

      <h4
        style={{
          fontSize: "1.1rem",
          color: "#28a745",
          marginBottom: "10px",
        }}
      >
        Description
      </h4>
      <div
        style={{
          fontSize: "14px",
          color: "#535665",
          marginBottom: "15px",
          textAlign: "left",
        }}
      >
        {product.discription}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Labels Section */}
        {product.labels && product.labels.length > 0 && (
          <div
            style={{
              // marginTop: "10px",
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              // marginBottom: "15px",
            }}
          >
            {product.labels.map((label, index) => (
              <div
                key={index}
                style={{
                  display: "inline-block",
                  background: "linear-gradient(135deg, #ff6f61, #ff4081)",
                  color: "#fff",
                  padding: "8px 15px",
                  borderRadius: "20px",
                  boxShadow: "0 3px 6px rgba(0, 0, 0, 0.2)",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  textTransform: "uppercase",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                  cursor: "default",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "scale(1.05)";
                  e.target.style.boxShadow = "0 5px 10px rgba(0, 0, 0, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "scale(1)";
                  e.target.style.boxShadow = "0 3px 6px rgba(0, 0, 0, 0.2)";
                }}
              >
                {label.name}
                {/* {label.description && (
                  <div
                    style={{
                      display: "block",
                      fontSize: "0.75rem",
                      fontWeight: "400",
                      textTransform: "none",
                      marginTop: "4px",
                      opacity: 0.9,
                    }}
                  >
                    {label.description}
                  </div>
                )} */}
              </div>
            ))}
          </div>
        )}

        {/* Tags Section */}
        {product.tags && product.tags.length > 0 && (
          <div
            style={{
              // marginTop: "10px",
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            {product.tags.map((tag, index) => (
              <div
                key={index}
                style={{
                  display: "inline-block",
                  background: "linear-gradient(135deg, #42a5f5, #1976d2)",
                  color: "#fff",
                  padding: "8px 15px",
                  borderRadius: "20px",
                  boxShadow: "0 3px 6px rgba(0, 0, 0, 0.2)",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  textTransform: "uppercase",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                  cursor: "default",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "scale(1.05)";
                  e.target.style.boxShadow = "0 5px 10px rgba(0, 0, 0, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "scale(1)";
                  e.target.style.boxShadow = "0 3px 6px rgba(0, 0, 0, 0.2)";
                }}
              >
                {tag.name}
                {/* {tag.description && (
                  <span
                    style={{
                      display: "block",
                      fontSize: "0.75rem",
                      fontWeight: "400",
                      textTransform: "none",
                      marginTop: "4px",
                      opacity: 0.9,
                    }}
                  >
                    {tag.description}
                  </span>
                )} */}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductDetails;
